import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import BetTableMuf from "../../casinoComponents/betTableMuf";
import VideoBox from "../../casinoComponents/videoBox";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import { getCasinoGameDetails, getMatchExposure, getCasinoOpenBets } from "../../../apiservices/CasionApi";
import ViewMoreModal from "../../../components/ViewMoreModal";
import { extractCasinoGame } from "../../../utils/casinoGame";
import ResultTeenMuf from "../resultui/resultTeenMuf/ResultTeenMuf";
import Teen20RefCardsOverlay from "../../casinoComponents/videoBox/overlays/Teen20RefCardsOverlay";
import VTeenMufView from "./VTeenMufView";
import TeenMufRightSide from "./TeenMufRightSide";
import "../../../styles/games/teenmuf.css";


export default function TeenPattiMuf() {
  const [gameData, setGameData] = useState(null);
  const [iframeSrc, setIframeSrc] = useState("");
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [subData, setSubData] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "teenmuf";

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "teenmuf";
    setIframeSrc(`https://stream-s-43.uhdmovies.online/casino-stream?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
        setSubData(response?.data?.data?.sub || []);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId =
        gameData?.data?.data?.t1?.gmid?.toString() ||
        gameData?.data?.data?.mid?.toString() ||
        gameData?.data?.mid?.toString() ||
        gameData?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const exposureAmount = parseFloat(item.exposure_amount) || 0;
            if (teamName) {
              exposureMap[teamName] = exposureAmount;
              exposureMap[teamName.toLowerCase()] = exposureAmount;
              exposureMap[teamName.trim()] = exposureAmount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [
    gameData?.data?.data?.t1?.gmid,
    gameData?.data?.data?.mid,
    gameData?.data?.mid,
    gameData?.mid,
  ]);

  const fetchMyBetsData = useCallback(async () => {
    const name = extractCasinoGame(pathname) || "teenmuf";
    if (!name) return;
    try {
      const response = await getCasinoOpenBets(name);
      if (response?.success && Array.isArray(response.data)) {
        const formattedBets = response.data.map((bet) => ({
          // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
          description: bet.description ?? bet.game_name ?? bet.gameName,
          userName: bet.username || bet.userName || "-",
          matchedBet: bet.matchedBet || bet.nation || bet.selection || bet.player_name || "-",
          selection: bet.selection || bet.player_name || bet.matchedBet || "",
          player_name: bet.player_name || "",
          odds: bet.odds ?? bet.userrate ?? "0",
          stake: bet.stake ?? bet.amount ?? "0",
          placeDate: bet.placeDate ?? bet.created_at ?? "-",
          gametype: bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
          type: bet.type || null,
          exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0,
        }));
        setMyBets(formattedBets);
      }
    } catch (error) {
      console.error("Error fetching my bets (open-downline):", error);
    }
  }, [pathname]);

  useEffect(() => {
    const matchId =
      gameData?.data?.data?.t1?.gmid?.toString() ||
      gameData?.data?.data?.mid?.toString() ||
      gameData?.data?.mid?.toString() ||
      gameData?.mid?.toString();

    if (matchId) {
      const t = setTimeout(() => fetchExposure(), 2000);
      const exposureInterval = setInterval(fetchExposure, 2000);
      return () => {
        clearTimeout(t);
        clearInterval(exposureInterval);
      };
    }
  }, [fetchExposure, gameData]);

  useEffect(() => {
    fetchMyBetsData();
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => clearInterval(intervalId);
  }, [fetchMyBetsData]);

  const handleBetClick = (value, betLabel, type, betData) => {
    if (!value) return;
    fetchExposure();
    fetchMyBetsData();
  };

  const d = gameData?.data?.data;
  const roundId = d?.mid || "";
  const viewMoreModal = (
    <ViewMoreModal
      show={showViewMoreModal}
      onHide={() => setShowViewMoreModal(false)}
      title="View More"
      sectionKey={gameName}
    />
  );

  // vcasino/teenmuf (API type vteenmuf): the reference renders a different, virtual-casino page
  if (gameName === "vteenmuf") {
    return (
      <VTeenMufView
        gameName={gameName}
        title="V-Muflis Teenpatti"
        data={d}
        exposures={exposures}
        onBetClick={handleBetClick}
        myBets={myBets}
        onViewMore={() => setShowViewMoreModal(true)}
        viewMoreModal={viewMoreModal}
      />
    );
  }

  // Reference markup: .casino-table.muflis has no .game-header — the title and round id sit in the
  // video (.casino-video-title, VideoBox titleNode); Last Result = LastResultsSection items.
  return (
    <CasinoTableLayout
      tableClass="muflis"
      rightSide={<TeenMufRightSide bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <VideoBox
          iframeSrc={iframeSrc}
          timerValue={d?.lt}
          gameType={gameName}
          titleNode={
            <div className="casino-video-title">
              <span className="casino-name">Muflis Teenpatti</span>{" "}
              <div className="casino-video-rid">Round ID: {roundId}</div>
            </div>
          }
          cardsOverlay={<Teen20RefCardsOverlay cards={d?.card} showNames={false} />}
        />
        {d?.mid ? (
          <div className="casino-detail">
            <BetTableMuf
              data={subData}
              onBetClick={handleBetClick}
              exposures={exposures}
              myBets={myBets}
            />{" "}
            {d?.remark ? (
              <div className="casino-remark mt-3">
                <div className="remark-icon">
                  <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
                </div>{" "}
                <marquee>{d.remark}</marquee>
              </div>
            ) : null}{" "}
            <CasinoLastResult
              gameType={gameName}
              resultComponent={<ResultTeenMuf gameType={gameName} fallbackTitle="Muflis Teenpatti" />}
            />
          </div>
        ) : null}
      </>
      {viewMoreModal}
    </CasinoTableLayout>
  );
}
